
<app-notification></app-notification>
<section class="has-block-padding-sm animated fadeIn" >
  <div class="row">
    <div class="col-md-4">
      <img src="../../../assets/images/landing/home/membership-img.webp" class="img-fluid">
    </div>
    <div class="col-md-7 offset-md-1 mt-3 mt-md-0">
      <h2 class="section-title">Contact us</h2>
      <p>If you have an emergency regarding your order (cancellation, etc), please call us or email us at <a><strong>info&#64;phillyfoodworks.com</strong></a></p>
      <p>If you have a general question, please consult our FAQ page. If you can't find the answer there, please send us an email or give us a call. Thanks!</p>
    </div>
  </div>
  <div class="has-padding-block-2">
    <div class="row">
      <div class="col-md-4">
        <div class="ul-icon-list has-no-circle">
          <span class="list-icon material-symbols-outlined">home</span>
          <div class="list-content">
            <h6>Address</h6>
            <p>1978 W Hunting Park Ave Philadelphia PA 19140</p>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="ul-icon-list has-no-circle">
          <span class="list-icon material-symbols-outlined">mail</span>
          <div class="list-content">
            <h6>Email</h6>
            <p>info&#64;phillyfoodworks.com</p>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="ul-icon-list has-no-circle">
          <span class="list-icon material-symbols-outlined">call</span>
          <div class="list-content">
            <h6>Phone (Day time)</h6>
            <p>(+1) 215 221 6245</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
